import { useTranslation } from 'react-i18next'
import i18n from '../i18n'
import zhCN from 'antd/locale/zh_CN'
import enUS from 'antd/locale/en_US'
import {CheckCircleTwoTone, ExclamationCircleTwoTone} from '@ant-design/icons'
import React, {useEffect, useState} from 'react';
import {Avatar, Breadcrumb, Calendar, Col, FloatButton, Layout, Menu, message, Row, Space, Spin, theme} from 'antd'
import {Outlet, Link, useSearchParams, useNavigate} from 'react-router-dom'
import ConfigProvider from "antd/es/config-provider"
import Select from "antd/es/select";
import axios from "axios";
import Tooltip from "antd/es/tooltip";
import Help from "./Help";
import Image from "antd/es/image";
import UserOutlined from "@ant-design/icons/lib/icons/UserOutlined";
import DownOutlined from "@ant-design/icons/lib/icons/DownOutlined";
import Dropdown from "antd/es/dropdown";
import Icon from "./Icon";
import {diffDaysHours, getExpireTime, globalData, isValidCode} from "../util/util";
import PlayerList from "./main/PlayerList";
import EmojiContainer from "./EmojiContainer";
import EmojiWindow from "./main/EmojiWindow";
const { Header, Content, Footer } = Layout;

// const old = document.location.origin.indexOf('localhost') > -1
const old = document.location.origin.indexOf('106.54.43.14') > -1


export default () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const [ll, setLl] = useState(enUS)
    const [ll2, setLl2] = useState('en')
    const [run, setRun] = useState(false)
    const [region, setRegion] = useState('0')

    const [selves, setSelves] = useState([])
    const [self, setSelf] = useState({})
    const [lastGame, setLastGame] = useState(null)

    let [expirObj, setExpirObj] = useState({days: 0,hours: 0})

    const hasNewPatch = () => {
        return '2025/11/5#2' !== localStorage.getItem('patches_read')
    }

    const isZh = i18n.language === 'zh'

    const updateAntdLang = () => {
        if (i18n.language == 'en') {
            setLl(enUS)
        } else {
            setLl(zhCN)
        }
    }

    useEffect(() => {
        if (self.handle) {
            globalData("handle", self.handle)
            localStorage.setItem("handleStr", self.handle + " " + self.sign)

            axios.get(`player/lastGame`).then(res => {
                if (res) {
                    setLastGame(res)
                }
            })

        }
    }, [self.handle])

    useEffect(() => {

        let selvesStr = localStorage.getItem('selves');
        let self0
        if (selvesStr) {
            let selves0 = JSON.parse(selvesStr)
            for (const selves0Element of selves0) {
                selves.push(selves0Element)
            }
            self0 = selves0[0]
            globalData("self", self0)
            setSelf(selves0[0])
        }

        let str = localStorage.getItem("touhou_emoji_keys")
        let keys = "0 0 0 0 0 0"
        if (str) {
            let arr = JSON.parse(str);
            if (arr.length === 6) {
                keys = arr.join(' ')
            }
        }
        if (self0) {
            if (self0.handle) {
                axios.post(`${axios.defaults.localURL}setConf`,
                    `${self0.handle} ${self0.clanTag ? self0.clanTag : '@'} ${keys}`).then(res => {})
            }
        }


        if (searchParams.get("aaa") === 1) {
            localStorage.setItem("aaa", "1")
        }
        let region = localStorage.getItem('region');
        if (region) {
            setRegion(region)
        }
        let lang = localStorage.getItem('lang');
        if (!lang) {
            lang = navigator.language
        }
        if (lang === 'zh-CN' || lang === 'zh') {
            setLl2('zh')
            i18n.changeLanguage('zh').then(() => {
                updateAntdLang()
            })

        } else {
            setLl2('en')
            i18n.changeLanguage('en').then(() => {
                updateAntdLang()
            })
        }

        let code = localStorage.getItem('code')
        let expir = localStorage.getItem('trial')


        async function fetchDataAsync() {
            let yes = await isValidCode(code)
            if (!yes && !expir) {
                localStorage.setItem('trial', expir = new Date(new Date().getTime() + 2 * 3600 * 1000).toJSON())
            }
            if (yes) {

                setExpirObj(Object.assign(expirObj, diffDaysHours(getExpireTime(code), new Date())))
            } else {

                setExpirObj(Object.assign(expirObj, diffDaysHours(new Date(expir), new Date())))
            }
            console.log(expirObj)

            if (expirObj.days > 0) {
                setRun(true)
            } else if (expirObj.days === 0 && expirObj.hours > 0) {
                setRun(true)
            }
        }
        fetchDataAsync().then();



        return () => {

        }

    }, [])

    return (<ConfigProvider locale={ll}>
        <Layout className="layout">
            <Header style={{ background: "#a0d911",paddingInline: "28px" }}>
                <Row>
                    <Col span={8}>
                        <div style={{width: "500px", fontSize: '20px', float: 'left'}} >
                            {
                                self.handle &&
                                <>
                                    <Space>
                                        <Link to={`/player/${self.handle}`} >
                                            <Space>
                                                <Icon type={'region'} name={self.handle.substr(0, 1)} size={32} />
                                                <Avatar src={`${self.pfp > 0 ? 'https://www.aslucky.club' : 'https://1'}/file/touhou/pfp/${self.handle}.png?r=${self.pfp}`} shape="square" size="large" icon={<UserOutlined />} />
                                                <div style={{  height:"30px", lineHeight: "30px", maxWidth: "160px",overflow: "hidden", whiteSpace: "nowrap",textOverflow: "ellipsis" }}>{self.name}</div>
                                            </Space>
                                        </Link>
                                        <Dropdown
                                            menu={{
                                                items: selves.map((p) => {
                                                    return {
                                                        key: p.handle,
                                                        label: <a onClick={() => {
                                                            localStorage.setItem("selves", JSON.stringify(selves.sort((a, b) => a.handle === p.handle ? -1 : 1)))
                                                            window.location.reload()
                                                        }}>
                                                            <Space>
                                                                <Icon type={'region'} name={p.handle.substr(0, 1)} size={24} />
                                                                <Avatar src={`${p.pfp > 0 ? 'https://www.aslucky.club' : 'https://1'}/file/touhou/pfp/${p.handle}.png?r=${p.pfp}`} shape="square" size="small" icon={<UserOutlined />} />
                                                                <span>{p.name}</span>
                                                            </Space>
                                                        </a>,
                                                    }
                                                })
                                            }}
                                        >
                                            <a onClick={(e ) => e.preventDefault()}><DownOutlined /></a>
                                        </Dropdown>
                                        {
                                            !lastGame ? <Spin /> :
                                            <div className={'noSelect clickAble'} style={{
                                                height: "42px",
                                                width: "200px",
                                                background: "#d9d9d9",
                                                textAlign: "center",
                                                lineHeight: "42px",
                                                borderRadius: "6px",
                                                fontSize: "20px",
                                            }}
                                                onClick={() => {
                                                    globalData("game", null)
                                                    navigate(`/match/${lastGame.gameId}`)
                                                }
                                                }
                                            >

                                                <Space>
                                                    <Icon style={{marginBottom: "6px"}} type={'hero'} name={lastGame.heroId} size={32} />
                                                    <b>{`${lastGame.kill}/${lastGame.death}/${lastGame.assist}`}</b>
                                                    <div>
                                                        {
                                                            lastGame.mmrChange >= 0 ? <b style={{ color: "#52c41a" }}>+</b> : null
                                                        }

                                                        <b style={{ color: lastGame.mmrChange >= 0 ? "#52c41a" : "#f5222d" }}>{lastGame.mmrChange}</b>
                                                    </div>
                                                </Space>
                                            </div>
                                        }
                                    </Space>
                                </> || null
                            }
                        </div>

                    </Col>
                    <Col span={8} style={{textAlign: "center"}}>
                        <Space size={40} style={{marginLeft: '0px'}}>
                            <Link className={'topBtn'} to={'matches'}>{t('matches')}</Link>
                            <Link className={'topBtn'} to={'heroes'}>{t('heroes')}</Link>
                            <Link className={'topBtn'} to={'players'}>{t('players')}</Link>
                            <Link className={'topBtn'} to={'ladders'}>{t('ladders')}</Link>
                            <div className="patch-wrapper" style={{position: 'relative', display: 'inline-block'}}>
                                <Link className="topBtn" to={'patches'}>{t('patches.patches')}</Link>
                                {hasNewPatch() && <span className="red-dot" />}
                            </div>
                        </Space>
                    </Col>
                    <Col span={8}>
                        <div style={{float: 'right'}}>
                            {
                                run
                                &&
                                <Tooltip color={"#52c41a"} title={t('tooltip.run')} >
                                    <CheckCircleTwoTone style={{fontSize: '24px', marginRight: '20px'}} twoToneColor="#52c41a" />
                                </Tooltip>
                                ||
                                <Tooltip color={"#f5222d"} title={t('tooltip.not_run')} >
                                    <ExclamationCircleTwoTone style={{fontSize: '24px', marginRight: '20px'}}  twoToneColor="#f5222d"/>
                                </Tooltip>

                            }

                            <Select
                                defaultValue="0"
                                value={region}
                                style={{ width: 80 }}
                                onChange={(v) => {
                                    setRegion(v)
                                    localStorage.setItem('region', v)
                                    window.location.reload()
                                }}
                                options={[
                                    {
                                        value: '0',
                                        label: t('region.all'),
                                    },
                                    {
                                        value: '3',
                                        label: t('region.kr'),
                                    },
                                    {
                                        value: '1',
                                        label: t('region.us'),
                                    },
                                    {
                                        value: '2',
                                        label: t('region.eu'),
                                    },
                                    {
                                        value: '5',
                                        label: t('region.cn'),
                                    },
                                ]}
                            />
                            <Select
                                defaultValue="en"
                                value={ll2}
                                onChange={(v) => {
                                    i18n.changeLanguage(v).then(r => {
                                        localStorage.setItem('lang', v)
                                        setLl2(v)
                                        updateAntdLang()
                                    })
                                }}
                                style={{ width: 100, marginLeft: '20px' }}
                                options={[
                                    {
                                        value: 'zh',
                                        label: '中文',
                                    },
                                    {
                                        value: 'en',
                                        label: 'English',
                                    },
                                ]}
                            />
                        </div>
                    </Col>
                </Row>
            </Header>
            <Content style={{ padding: '50px', paddingTop: "0px", minHeight: '900px',height: 'auto', textAlign: 'center'}}>
                <Space direction={"vertical"}>
                    <div style={{ marginTop: "25px",marginBottom: "25px" }}>
                        {


                            <Space style={{fontSize: '28px'}}>
                                {
                                    run && <b>
                                        {isZh
                                            ? `还有 ${expirObj.days} 天 ${expirObj.hours} 小时到期`
                                            : `Expires in ${expirObj.days} days ${expirObj.hours} hours`}
                                    </b>
                                    || <b>{isZh ? "已过期" : "Expired"}</b>
                                }
                                <Link to={'help'}>{t('subscribe')}</Link>

                            </Space>

                        }

                    </div>
                    <div className="site-layout-content">
                        {

                            (run && (<><Outlet /><PlayerList /><EmojiWindow /></>) || <Help />)


                        }
                    </div>

                </Space>
            </Content>
            <Footer style={{ width: "100%", textAlign: 'center' }}>Open TBA ©2026 Created by {t('author')}</Footer>
        </Layout>
    </ConfigProvider>)


}
